<ng-container *transloco="let t; read: 'onlinetest'">
  <div class="file-list" role="navigation">
    <div *ngIf="onlinetest !== null" class="nav-block">
      <p class="topline">
        {{ t('report_files') }}
      </p>
      <ul *ngIf="otCandidate?.resources?.length > 0">
        <li *ngFor="let report of otCandidate.resources">
          <fa-icon class="p-pr-2" [icon]="faFileAlt"></fa-icon>
          <a (click)="downloadFile(report)" (keyup.enter)="downloadFile(report)" tabindex="0">{{ report.public_name }}</a>
        </li>
      </ul>
      <p class="no-files" *ngIf="otCandidate?.resources?.length === 0">
        {{ t('no_report_files') }}
      </p>
      <p *ngIf="auth.isModerator()">
        <button *ngIf="loading !== true" class="p-button-sm p-mt-1" (click)="loadReports()" pButton type="button" icon="pi pi-refresh" [label]="t('refresh')"></button>
        <button *ngIf="loading === true" class="p-button-sm p-mt-1" pButton type="button" icon="pi pi-spin pi-spinner" [label]="t('refresh')" [disabled]="true"></button>
      </p>
    </div>
  </div>
</ng-container>
